(() => {
  // Helpers
  const $ = (sel, ctx = document) => ctx.querySelector(sel);

  // Stato iniziale
  const gridSel = '[data-facets-product-grid]';
  const grid = $(gridSel);
  const paginationWrap = $('[data-pagination]');
  const sentinel = document.getElementById('infinite-sentinel');
  const status = document.getElementById('infinite-status');
  const container = document.querySelector('[data-facets-products-grid-container]') || document.body;

  if (!grid || !paginationWrap || !sentinel) return;

  // Prende l'ID sezione dal markup (serve per la Section Rendering API)
  const sectionId = grid.getAttribute('data-id');

  // Pagina corrente dedotta dall'URL (?page=) o 1 di default
  const urlNow = new URL(window.location.href);
  let currentPage = parseInt(urlNow.searchParams.get('page') || '1', 10);
  if (isNaN(currentPage) || currentPage < 1) currentPage = 1;

  // Evita richieste duplicate sulla stessa pagina
  const seenPages = new Set([currentPage]);

  // Set di handle già presenti per prevenire duplicati
  const seenHandles = new Set();
  const collectHandles = (root) => {
    root.querySelectorAll('li, .product-card, [data-product-handle]').forEach((node) => {
      let handle = node.getAttribute('data-product-handle');
      if (!handle) {
        const a = node.querySelector('a[href*="/products/"]');
        if (a) {
          try {
            const u = new URL(a.getAttribute('href'), window.location.origin);
            const parts = u.pathname.split('/products/');
            if (parts[1]) handle = parts[1].split('/')[0];
          } catch (_) {}
        }
      }
      if (handle) seenHandles.add(handle);
    });
  };
  collectHandles(grid);

  const setStatus = (msg) => { if (status) status.textContent = msg || ''; };

  // Costruisce l'URL per la pagina successiva, mantenendo filtri/ordinamento
  const buildNextUrl = (nextPage) => {
    const base = new URL(window.location.href);
    // preserva tutti i parametri (filter.*, sort_by, ecc.)
    // e aggiorna solo 'page'
    base.searchParams.set('page', String(nextPage));
    // usa Section Rendering API per farti restituire solo la sezione (più stabile)
    base.searchParams.set('section_id', sectionId);
    return base;
  };

  // Calcola il numero di pagine totali (se possibile) leggendo i numeri nella paginazione
  const getTotalPagesFromPagination = () => {
    const nums = [...paginationWrap.querySelectorAll('a, span')]
      .map(el => parseInt(el.textContent.trim(), 10))
      .filter(n => !isNaN(n));
    return nums.length ? Math.max(...nums) : null;
  };
  let totalPages = getTotalPagesFromPagination();

  let loading = false;
  let io;

  const appendProducts = (newGrid) => {
    if (!newGrid) return 0;
    const items = Array.from(newGrid.children);
    const frag = document.createDocumentFragment();
    let appended = 0;

    items.forEach((node) => {
      // Dup-check per handle prodotto
      let handle = node.getAttribute('data-product-handle');
      if (!handle) {
        const a = node.querySelector('a[href*="/products/"]');
        if (a) {
          try {
            const u = new URL(a.getAttribute('href'), window.location.origin);
            const parts = u.pathname.split('/products/');
            if (parts[1]) handle = parts[1].split('/')[0];
          } catch (_) {}
        }
      }
      if (handle && seenHandles.has(handle)) {
        return; // skip duplicato
      }
      if (handle) seenHandles.add(handle);
      frag.appendChild(node);
      appended++;
    });

    if (appended) grid.appendChild(frag);
    return appended;
  };

  const loadNextPage = async () => {
    if (loading) return;

    // Se conosciamo il totale e siamo all'ultima pagina, stop
    if (totalPages && currentPage >= totalPages) {
      disconnect();
      setStatus('Hai visto tutti i prodotti.');
      return;
    }

    const nextPage = currentPage + 1;
    if (seenPages.has(nextPage)) return; // già provata

    loading = true;
    setStatus('Carico altri prodotti…');

    try {
      const nextUrl = buildNextUrl(nextPage);

      const res = await fetch(nextUrl.toString(), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      const html = await res.text();

      // La Section Rendering API ritorna HTML della sezione: usiamo un container temporaneo
      const tmp = document.createElement('div');
      tmp.innerHTML = html;

      const newGrid = tmp.querySelector(gridSel);
      const newPagination = tmp.querySelector('[data-pagination]');

      // Appendi solo elementi nuovi (deduplicati)
      const added = appendProducts(newGrid);

      // Aggiorna paginazione (così possiamo ricalcolare totalPages)
      if (paginationWrap) {
        if (newPagination) {
          paginationWrap.innerHTML = newPagination.innerHTML;
          totalPages = getTotalPagesFromPagination() || totalPages;
        } else {
          // se la nuova sezione non include più paginazione, probabilmente siamo all'ultima
          paginationWrap.innerHTML = '';
          totalPages = currentPage + 1; // forza lo stop al prossimo controllo
        }
      }

      // Se non abbiamo aggiunto nulla, evita loop infiniti
      if (added === 0) {
        disconnect();
        setStatus('Nessun altro prodotto disponibile.');
        return;
      }

      // Avanza pagina
      currentPage = nextPage;
      seenPages.add(currentPage);

    } catch (err) {
      console.error('Infinite scroll error:', err);
      // Mostra paginazione classica e ferma l'infinite
      paginationWrap.classList.remove('pagination--infinite');
      setStatus('Impossibile caricare altri prodotti. Usa la paginazione.');
      disconnect();
    } finally {
      loading = false;
      setTimeout(() => setStatus(''), 800);
    }
  };

  const observe = () => {
    if (!sentinel) return;
    io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !loading) loadNextPage();
      });
    }, { rootMargin: '800px 0px 800px 0px' });
    io.observe(sentinel);
  };

  const disconnect = () => { if (io) { io.disconnect(); io = null; } };

  // Se i filtri rimpiazzano il markup, ri-aggancia tutto
  const mo = new MutationObserver(() => {
    disconnect();
    // ricolleziona handle (nuova griglia)
    const newGrid = $(gridSel);
    if (newGrid && newGrid !== grid) collectHandles(newGrid);
    observe();
  });
  mo.observe(container, { childList: true, subtree: true });

  // Start
  observe();
})();
